import { AppTheme } from '../../../../../main-service/infrastructure/types/features/themes/theme-types';
import { colorsPalette } from '../../colors-palette';

const colors = {
  primaryColor: colorsPalette.dustyBlue500 as Color,
  defaultHoverColor: colorsPalette.dustyBlue500 as Color,
  defaultHoverBorderColor: colorsPalette.dustyBlue500 as Color,
  defaultActiveColor: colorsPalette.dustyBlue500 as Color,
  defaultActiveBorderColor: colorsPalette.dustyBlue500 as Color,
};

const defaultTheme: AppTheme = {
  id: 'default',
  colors: colors,
  font: 'SkorozvonRoboto' as Font,
  components: {
    button: {
      primary: {
        brandColor: colorsPalette.green400 as Color,
        border: colorsPalette.green400 as Color,
        hover: colorsPalette.green300 as Color,
        textColor: colorsPalette.white as Color,
        active: colorsPalette.green400 as Color,
      },
      default: {
        hover: colorsPalette.dustyBlue500 as Color,
        hoverBorder: colorsPalette.lightGray400 as Color,
        active: colorsPalette.gray300 as Color,
        activeBorder: colorsPalette.gray600 as Color,
      },
    },
    steps: {
      primary: {
        brandColor: colorsPalette.green300 as Color,
      },
    },
    input: {
      primary: {
        hover: colorsPalette.dustyBlue500 as Color,
        borderActiveColor: colorsPalette.dustyBlue500 as Color,
      },
    },
    notification: {
      info: {
        brandColor: colorsPalette.yellow650 as Color,
      },
      primary: {
        brandColor: colorsPalette.yellow650 as Color,
      },
    },
    menu: {
      primary: {
        itemSelectedColor: colorsPalette.dustyBlue500 as Color,
      },
    },
    progress: {
      default: {
        color: colorsPalette.green300 as Color,
      },
    },
    tabs: {
      primary: {
        brandColor: colorsPalette.dustyBlue500 as Color,
      },
    },
    datePicker: {
      primary: {
        brandColor: colorsPalette.dustyBlue500 as Color,
        hover: colorsPalette.dustyBlue300 as Color,
        border: colorsPalette.dustyBlue200 as Color,
        active: colorsPalette.dustyBlue600 as Color,
      },
    },
  },
};

export default defaultTheme;
